
export default {
  data() {
    return {
      title: "Шкала тревоги Бека (BAI)",
      resultOnly: false,
      testDone: false,
      lenght: 0,
      items: [],
      colors: ["green", "lime", "amber"],
      results: [
        {
          name: "Суммарный бал",
          steps: [...Array(21)].map((item, index) => index),
          overall: 21 * 3,
          value: 0,
          prc: 0,
          outcome: {
            1: {
              from: 0,
              to: 21,
              text: "Низкая тревожность",
            },
            2: {
              from: 22,
              to: 35,
              text: "Средняя тревожность",
            },
            3: {
              from: 36,
              to: 21 * 3,
              text: "Потенциально опасный уровень беспокойства и тревоги",
            },
          },
        },
      ],
      questions: [
        "Ощущение онемения или покалывания в теле",
        "Ощущение жары",
        "Дрожь в ногах",
        "Неспособность расслабиться",
        "Страх, что произойдет самое плохое",
        "Головокружение или ощущение легкости в голове",
        "Ускоренное сердцебиение",
        "Неустойчивость",
        "Ощущение ужаса",
        "Нервозность",
        "Дрожь в руках",
        "Ощущение удушья",
        "Шаткость походки",
        "Страх утраты контроля",
        "Затрудненность дыхания",
        "Страх смерти",
        "Испуг",
        "Желудочно-кишечные расстройства",
        "Обмороки",
        "Приливы крови к лицу",
        "Усиление потоотделения (не связанное с жарой)",
      ],
      options: [
        "Совсем не беспокоит",
        "Слегка. Не слишком меня беспокоит",
        "Умеренно. Это было неприятно, но я могу это перенести",
        "Очень сильно. Я с трудом могу это переносить",
      ],
    };
  },
  computed: {
    breadcrumbs: function () {
      let items = [
        {
          text: "Консультации",
          disabled: false,
          href: "/",
        },
      ];

      items.push({
        text: "Психологические тесты",
        disabled: false,
        href: "/test/",
      });

      items.push({
        text: this.title,
        disabled: true,
        href: "/test/shkala-trevogi-beka-bai/",
      });

      return items;
    },
  },
  created() {
    this.questions.forEach((item, index) => {
      this.lenght++;
      this.items.push({
        name: item,
        id: index + 1,
        options: this.options,
        selected: -1,
      });
    });
  },
  mounted() {
    if (process.client && ym !== undefined && !this.$config.isDev) {
      ym("73133527", "hit", this.canonicalURL(), {
        title: this.title,
      });
    }
  },
  methods: {
    updateResults: function (newResults) {
      this.results = newResults;
      this.resultOnly = true;
      this.testDone = true;
    },
    updateItems: function (newItems) {
      this.items = newItems;
      this.calculateResult();
    },
    calculateResult: function () {
      let selectedCount = 0;
      this.results.forEach((res, resID) => {
        this.results[resID].value = 0;
        res.steps.forEach((itemID) => {
          this.results[resID].value += this.items[itemID].selected;
        });
        this.results[resID].prc = Math.round(
          (this.results[resID].value / this.results[resID].overall) * 100
        );
      });
      this.items.forEach((item) => {
        if (item.selected >= 0) {
          selectedCount++;
        }
      });
      this.testDone = selectedCount == this.items.length;
    },
    canonicalURL: function () {
      if (this.$route.path[this.$route.path.length - 1] == "/") {
        return this.$config.wwwURL + this.$route.path;
      } else {
        return this.$config.wwwURL + this.$route.path + "/";
      }
    },
  },
  head() {
    return {
      title: this.title,
      description:
        this.title +
        ". Тесты используемые психологом в работе. Результатами основной части тестов можно поделиться по ссылке.",
      meta: [
        {
          name: "description",
          content:
            this.title +
            ". Тесты используемые психологом в работе. Результатами основной части тестов можно поделиться по ссылке.",
        },
        { property: "og:title", content: this.title },
        { property: "og:url", content: this.canonicalURL() },
        {
          property: "og:site_name",
          content: "Психология для вас - Елена Елизарова",
        },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://www.elena-elizarova.ru/images/avatar.png",
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
